export default __webpack_public_path__ + "static/GlobalImgTwo-88f3ead02736884ed01d3af756783431.webp";